<script setup>
import ExposureTable from '@/views/quality/infection-control/exposure/ExposureTable.vue'
import ExposureDrawer from '@/views/quality/infection-control/exposure/ExposureDrawer.vue'

definePage({
  meta: {
    subject: 'quality.infection_control.menu',
    action: 'staff_exposure',
  },
})

const isDrawerVisible = ref(false)
const selectedItem = ref(null)

const exposureTableRef = ref()

const openDrawer = (item = null) => {
  selectedItem.value = item
  isDrawerVisible.value = true
}

watch(isDrawerVisible, val => {
  if (!val) selectedItem.value = null
})
</script>

<template>
  <section>
    <ExposureTable
      ref="exposureTableRef"
      @add="openDrawer(null)"
      @edit="openDrawer"
    />

    <ExposureDrawer
      v-model:is-drawer-open="isDrawerVisible"
      :form-data="selectedItem"
      @refetch-listing="exposureTableRef?.fetchTable()"
    />
  </section>
</template>
